module.exports = __webpack_public_path__ + "img/face.f951cca0.svg";